module.exports = "<div class=\"error-div\" *ngIf=\"getValidatoinMessage()\">\n    {{getValidatoinMessage()}}\n</div>\n"